<template>
  <div class="container h-100" v-loading="loading">
    <div class="d-flex justify-content-center align-items-center h-100">
      <div class="base-screen">
          <b-card class="form-screen">
              <b-alert show variant="danger" style="text-align: center" v-if="sessionExpired">{{lang.label.alert}}</b-alert>
              <div class="text-center">
            <img src="../assets/styles/img/logo-large.png" alt="Image placeholder" class="logo-img" />
          </div>
          <div class="row">
            <div class="col-12">
              <ValidationObserver ref="observer" v-slot="{ passes }">
                <b-form @submit.stop.prevent="passes(getOTP)">
<!--                <b-form @submit.prevent="handleSubmit">-->
                  <b-form-group>
<!--                    <label class="label-control" for="mobile number">{{lang.label.mobileNumber}}: <span class="text-danger">*</span></label>-->

                    <ValidationProvider
                      name="mobile number"
                      rules="required|digits:10"
                      v-slot="validationContext"
                      class="phone-input-group phone-group"
                    >  
                      <b-form-input
                        :state="getValidationState(validationContext)"
                        v-model="models.mobileNumber"
                        id="mobileNumber"
                        type="text"
                        @keypress="isNumber($event)"
                        name="number"
                        :placeholder="lang.label.enterNumber"
                      ></b-form-input>
                      <span>{{lang.label.mobileExample}}</span><br />
                      <span style="color: red;font-size: 12px;" v-if="mobileError">{{lang.label.mobileError}}</span>
                      <span style="color: red;font-size: 12px;" v-if="validationContext.failedRules.required && !mobileError"> {{lang.label.validationMessages.mobileRequired}}</span>
                     <br/>
                     <span style="color: red;font-size: 12px;" v-if="validationContext.failedRules.digits && !mobileError"> {{lang.label.validationMessages.mobilenumLength}}</span>
                      <!--<b-form-invalid-feedback v-if="!mobileError">{{ validationContext.errors[0] }}</b-form-invalid-feedback>-->
                    </ValidationProvider>
                  </b-form-group>
                  <b-form-group class="mb-0 btn-mt">
                    <b-btn
                      type="submit"
                      variant="primary"
                      class="w-100"
                    >{{lang.label.buttons.login}}</b-btn>
                  </b-form-group>
                </b-form>
              </ValidationObserver>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>

  import {mapGetters} from "vuex";
  import * as validate from 'vee-validate';

  export default {
  props: ["title", "id"],
  components: {},
  data() {
    return {
      lang: this.$lang.login,
      otp: "",
      mobileError: false,
      models: {
        mobileNumber: "",
        password: "",
      }
    };
  },
  watch: {
    mobileNumber(val){
        this.$store.commit('setSessionExpired',false);
      if(val.slice(0,1) != 0){
        this.mobileError = true;
      }else{
        this.mobileError = false;
      }
    }
  },
  computed: {
    ...mapGetters({
        login: "login",
        loading: "loading",
        sessionExpired: "sessionExpired",
        unauthorized:"unauthorized",
    }),
    mobileNumber(){
      return this.models.mobileNumber;
    }
  },
  mounted(){
      let self = this;
      this.$store.commit('setLoading',false);
      this.$store.dispatch('contactDetails').then(value => {
          if(value.data){
              let time = value.data.otpExpiredTime;
              if(time){
                  self.$store.commit('setTimeForOtp',time);
              }
          }
      });
  },
  methods: {
    isNumber(type,evt) {
          evt = (evt) ? evt : window.event;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
              if (this.models.mobileNumber.length >= 10) {
                  evt.preventDefault();
              }
          if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
              evt.preventDefault();
          } else {
              return true;
          }
      },
    getOTP(){
        if(!this.mobileError){
            this.$store.dispatch('sendOtp',{"mobile" : this.models.mobileNumber}).then(response => {
                if(response.data.otp){
                    localStorage.setItem('mobile_number',this.models.mobileNumber);
                    localStorage.setItem('password',response.data.otp);
                    this.$router.push({name: 'otp'});
                }else{
                    this.$router.push({name: 'contact-details'});
                }
            })
        }else{
            $("#mobileNumber").focus();
        }

    },
    getImgUrl(pic) {
      return require("../assets/styles/img/" + pic);
    },
    getValidationState({ dirty, validated, valid = null }) {
        if(this.mobileError){
            return false;
        }else{
            return dirty || validated ? valid : null;
        }
    },
    onSubmit() {
    }
  }
};
</script>

